export enum JobStatus {
  DONE = 'done',
  NEW = 'new',
  PROCESSING = 'processing',
  FAILED = 'failed',
}
